<template>
  <div
    class="wow_custom_order_banner t-white d-flex-row justify-start"
    :class="currentGameSlug"
    @click="openChat"
  >
    <div
      class="d-flex-column gap-0 justify-start align-start flex-5 flex-md-10"
    >
      <h3 class="title-h3 title font-family-1 f-w-600">
        {{ $t(`new.custom_order`) }}
      </h3>
      <h3 class="title-h3 t-white font-family-1 f-w-600">
        WoW {{ $t("new.boosting_services") }}
      </h3>
      <p class="t-light font-family-2 regular-l" style="margin-top: 9px">
        {{ $t(`new.custom_order_desc`) }}
      </p>

      <div class="arrow_right cursor-pointer" style="margin-top: 36px">
        <h4
          class="t-white bold-s f-w-600 font-family-1 text white-space-no flex-4"
        >
          {{ $t("main.buy_now") }}
        </h4>
        <arrow-right />
      </div>
    </div>
  </div>
</template>

<script>
import ArrowRight from "../icons/ArrowRight.vue";

export default {
  data() {
    return {};
  },

  components: {
    ArrowRight,
  },
  setup() {
    const { currentGameSlug } = useGameComposable();
    const { openChat } = useCrispComposable();

    return {
      currentGameSlug,
      openChat,
    };
  },
};
</script>
